import { render, staticRenderFns } from "./TargetUrl.vue?vue&type=template&id=74fd434a&scoped=true&"
import script from "./TargetUrl.vue?vue&type=script&lang=js&"
export * from "./TargetUrl.vue?vue&type=script&lang=js&"
import style0 from "./TargetUrl.vue?vue&type=style&index=0&id=74fd434a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fd434a",
  null
  
)

/* custom blocks */
import block0 from "./TargetUrl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports